import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'accountFormat',
    standalone: true,
})
export class AccountFormatPipe implements PipeTransform {
    transform(value: number | string): any {
        const stringValue = (value ?? '').toString();
        if (stringValue === '') {
            return '';
        }
        if (stringValue.length <= 1) {
            return stringValue;
        }
        const accountNumbers = stringValue.slice(0, -1);
        // '4545454' converts to 454545-4
        return `${accountNumbers}-${stringValue.at(-1)}`;
    }
}
